import * as React from 'react';

import { use$ } from '@legendapp/state/react';
import styled from 'styled-components';

import { DeviceOrientation, deviceSettingStore } from '../../store';

export const HotAreas = () => {
	const deviceOrientation = use$(deviceSettingStore.deviceOrientation);

	return (
		<>
			<TopHotArea $hidden={deviceOrientation === DeviceOrientation.Landscape} />
			<SideHotArea />
			<SideHotArea $mirror />
		</>
	);
};

const TopHotArea = styled.div<{ $hidden?: boolean }>`
	${props => props.$hidden && 'display:none;'}
	position: absolute;
	width: 100%;
	height: 48px;
	pointer-events: all;
`;

const SideHotArea = styled.div<{ $mirror?: boolean }>`
	position: absolute;
	width: 48px;
	height: 100%;
	${props => (props.$mirror ? 'right: 0;' : 'left:0;')}
	pointer-events: all;
`;
